import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthenticateApiService } from "@services/rest/authenticate-api.service";
import { TokenService } from '@services/rest/token.service';
import { AuthenticateRequestModel } from "@model/authenticate.model";
import { Router, ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from 'ngx-spinner';
import { catchError, finalize } from 'rxjs/operators';
import { EMPTY, throwError } from 'rxjs';


@Component({
    selector: 'app-dashboard',
    templateUrl: 'login.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})


export class LoginComponent implements OnInit {

  form!: UntypedFormGroup;
    submitted = false;
  isSubmitting = false;
    authenticateRequestModel : AuthenticateRequestModel={};
    returnUrl = "/dashboard";
  constructor( 
      private authenticateApiService: AuthenticateApiService,
      private router: Router,
      private route: ActivatedRoute,
      private notification: NzNotificationService,
      private tokenService: TokenService,
      private formBuilder: UntypedFormBuilder,
      private spinner: NgxSpinnerService,
      private cdr: ChangeDetectorRef,
  )
  {
  }
  
  ngOnInit(): void {
      this.route.queryParams.subscribe(params => {
        const returnUrl = params['returnUrl'];
        // Reject returnUrls pointing back at auth pages ('/' also renders this
        // login component) so a successful sign-in always leaves this page.
        this.returnUrl = returnUrl && !this.isAuthUrl(returnUrl)
          ? returnUrl
          : '/dashboard';
      });
      this.form = this.formBuilder.group({
        username: ['', [Validators.required]],
        password: ['', [Validators.required]]
        
    });

  }

  onSubmit(){

    if (this.isSubmitting) {
      return;
    }

    this.submitted = true;

    if (this.form.invalid) {
        return;
    }

    this.isSubmitting = true;
    this.spinner.show();   

    this.authenticateRequestModel.username = this.f.username.value;
    this.authenticateRequestModel.password = this.f.password.value;
    this.authenticateApiService
      .Authenticate( this.authenticateRequestModel)
      .pipe(
        catchError(err => {
          if (err.status === 0 && err.error instanceof ProgressEvent) {
             this.showNotification("Connection failed",false);          
          } 
          return EMPTY;
        }),
        
        finalize(() => {
          this.isSubmitting = false;
          this.spinner.hide();
          this.cdr.markForCheck();
        })
      )
      .subscribe(response => {
        if(response.success === false)
        {
          this.showNotification(response.errorMessage,response.success);          
        }else{
          this.tokenService.setAccessToken(response.accessToken);
          this.tokenService.setUser(JSON.stringify(response.user));
          this.tokenService.setPermissions(response.permissionNames);
          this.tokenService.setBranch(JSON.stringify(response.branch));
          this.tokenService.setRoles(response.roles);
          this.tokenService.setExpiryTime(response.expiresOnUtc)
          this.tokenService.setRefreshToken(response.refreshToken)
          this.router.navigateByUrl(this.returnUrl);
        }
      });
  }

  get f(): { [key: string]: AbstractControl; } {
    return this.form.controls;
  }

  private isAuthUrl(url: string): boolean {
    const path = (url || '').split('?')[0].split('#')[0];
    return path === '' || path === '/'
      || path.startsWith('/login')
      || path.startsWith('/404')
      || path.startsWith('/500');
  }

  showNotification(message: string, status: boolean){
    if(status === true){
        this.notification.success(message,""); 
    }
    else{
        this.notification.error(message,"");
    }
  }

}
